// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

export async function login(options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/account/login', {
    method: 'POST',
    data: options,
  });
}

export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/account/info', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getAadUrl(options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/aad/url', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function outLogin(options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/account/loginout', {
    method: 'POST',
    ...(options || {}),
  });
}

export async function user_list(params?: any, sort?: any, options?: { [key: string]: any },) {
  return request<API.ApiResult>('/api/account/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: {...params}
    },
    ...(options || {}),
  });
}

export async function edit_user(options: { [key: string]: any }){
  let url = options.type === 0 ? '/api/account/add' : '/api/account/edit';
  return request<API.ApiResult>(url, {
    method: 'POST',
    data: options,
  });
}

export async function role_list(params?: any, sort?: any, options?: { [key: string]: any },) {
  return request<API.ApiResult>('/api/role/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: {...params}
    },
    ...(options || {}),
  });
}

export async function edit_role(options: { [key: string]: any }){
  let url = options.type === 0 ? '/api/role/add' : '/api/role/edit';
  return request<API.ApiResult>(url, {
    method: 'POST',
    data: options,
  });
}

export async function role_value_enum() {
  return request<API.ApiResult>('/api/role/valueEnum', {
    method: 'POST',
    data: {}
  });
}

export async function log_list(params?: any, sort?: any, options?: { [key: string]: any },) {
  return request<API.ApiResult>('/api/log/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: {...params}
    },
    ...(options || {}),
  });
}

export async function dict_list(params?: any, sort?: any, options?: { [key: string]: any },) {
  return request<API.ApiResult>('/api/dictType/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: {...params}
    },
    ...(options || {}),
  });
}

export async function edit_dict(options: { [key: string]: any }){
  let url = options.type === 0 ? '/api/dictType/add' : '/api/dictType/edit';
  return request<API.ApiResult>(url, {
    method: 'POST',
    data: options,
  });
}

export async function dictItem_list(params?: any, sort?: any, options?: { [key: string]: any },) {
  return request<API.ApiResult>('/api/dictItem/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: {...params}
    },
    ...(options || {}),
  });
}

export async function edit_dictItem(options: { [key: string]: any }){
  let url = options.type === 0 ? '/api/dictItem/add' : '/api/dictItem/edit';
  return request<API.ApiResult>(url, {
    method: 'POST',
    data: options,
  });
}

export async function select_value_enum(type: string) {
  return request<API.ApiResult>('/api/dictItem/getOptions', {
    method: 'POST',
    data: {dictType: type},
  });
}


export async function project_list(params?: any, sort?: any, options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/project/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: { ...params },
    },
    ...(options || {}),
  });
}

export async function edit_project(options: { [key: string]: any }) {
  const url = options.type === 0 ? '/api/project/add' : '/api/project/edit';
  return request<API.ApiResult>(url, {
    method: 'POST',
    data: options,
  });
}

export async function del_project(id?: string) {
  return request<API.ApiResult>('/api/project/delete', {
    method: 'POST',
    params: { id },
  });
}

export async function project_value_enum() {
  return request<API.ApiResult>('/api/project/valueEnum', {
    method: 'POST',
    data: {},
  });
}

export async function boardtask_list(params?: any, sort?: any, options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/boardtask/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: { ...params },
    },
    ...(options || {}),
  });
}

export async function edit_boardtask(options: { [key: string]: any }) {
  const url = options.type === 0 ? '/api/boardtask/add' : '/api/boardtask/edit';
  return request<API.ApiResult>(url, {
    method: 'POST',
    data: options,
  });
}

export async function del_boardtask(id?: string) {
  return request<API.ApiResult>('/api/boardtask/delete', {
    method: 'POST',
    params: { id },
  });
}

export async function boardtask_board(options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/boardtask/board', {
    method: 'POST',
    data: options || {},
  });
}

export async function boardtask_update_status(options: { [key: string]: any }) {
  return request<API.ApiResult>('/api/boardtask/updatestatus', {
    method: 'POST',
    data: options,
  });
}

export async function boardtask_update_progress(options: { [key: string]: any }) {
  return request<API.ApiResult>('/api/boardtask/updateprogress', {
    method: 'POST',
    data: options,
  });
}

export async function boardtask_update_order(options: { [key: string]: any }) {
  return request<API.ApiResult>('/api/boardtask/updateorder', {
    method: 'POST',
    data: options,
  });
}

export async function boardtask_statistics(projectId?: string) {
  return request<API.ApiResult>('/api/boardtask/statistics', {
    method: 'GET',
    params: { projectId },
  });
}

export async function quotation_list(params?: any, sort?: any, options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/quotation/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: { ...params },
    },
    ...(options || {}),
  });
}

export async function edit_quotation(options: { [key: string]: any }) {
  const url = options.type === 0 ? '/api/quotation/add' : '/api/quotation/edit';
  return request<API.ApiResult>(url, {
    method: 'POST',
    data: options,
  });
}

export async function del_quotation(id?: string) {
  return request<API.ApiResult>('/api/quotation/delete', {
    method: 'POST',
    params: { id },
  });
}

export async function quotation_convert(id?: string) {
  return request<API.ApiResult>('/api/quotation/convert', {
    method: 'POST',
    params: { id },
  });
}

export async function quotation_select_options() {
  return request<API.ApiResult>('/api/quotation/selectoptions', {
    method: 'GET',
  });
}

export async function receivable_list(params?: any, sort?: any, options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/receivable/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: { ...params },
    },
    ...(options || {}),
  });
}

export async function edit_receivable(options: { [key: string]: any }) {
  return request<API.ApiResult>('/api/receivable/edit', {
    method: 'POST',
    data: options,
  });
}

export async function del_receivable(id?: string) {
  return request<API.ApiResult>('/api/receivable/delete', {
    method: 'POST',
    params: { id },
  });
}

export async function payment_list(params?: any, sort?: any, options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/payment/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: { ...params },
    },
    ...(options || {}),
  });
}

export async function add_payment(options: { [key: string]: any }) {
  return request<API.ApiResult>('/api/payment/add', {
    method: 'POST',
    data: options,
  });
}

export async function del_payment(id?: string) {
  return request<API.ApiResult>('/api/payment/delete', {
    method: 'POST',
    params: { id },
  });
}

export async function billbook_list(params?: any, sort?: any, options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/billbook/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: { ...params },
    },
    ...(options || {}),
  });
}

export async function edit_billbook(options: { [key: string]: any }) {
  const url = options.type === 0 ? '/api/billbook/add' : '/api/billbook/edit';
  return request<API.ApiResult>(url, {
    method: 'POST',
    data: options,
  });
}

export async function del_billbook(id?: string) {
  return request<API.ApiResult>('/api/billbook/delete', {
    method: 'POST',
    params: { id },
  });
}

export async function billbook_select_options() {
  return request<API.ApiResult>('/api/billbook/selectoptions', {
    method: 'GET',
  });
}

export async function billrecord_list(params?: any, sort?: any, options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/billrecord/list', {
    method: 'POST',
    data: {
      current: params.current,
      pageSize: params.pageSize,
      sort,
      filter: { ...params },
    },
    ...(options || {}),
  });
}

export async function edit_billrecord(options: { [key: string]: any }) {
  const url = options.type === 0 ? '/api/billrecord/add' : '/api/billrecord/edit';
  return request<API.ApiResult>(url, {
    method: 'POST',
    data: options,
  });
}

export async function batch_add_billrecord(options: { [key: string]: any }) {
  return request<API.ApiResult>('/api/billrecord/batchadd', {
    method: 'POST',
    data: options,
  });
}

export async function del_billrecord(id?: string) {
  return request<API.ApiResult>('/api/billrecord/delete', {
    method: 'POST',
    params: { id },
  });
}

export async function billrecord_statistics(options?: { [key: string]: any }) {
  return request<API.ApiResult>('/api/billrecord/statistics', {
    method: 'POST',
    data: options || {},
  });
}

export async function finance_report_overview() {
  return request<API.ApiResult>('/api/financeReport/overview', {
    method: 'GET',
  });
}
















